import TokenService from "./tokenService.js";
import AuthService from "./authService.js";
import * as previaStudio from "./previaStudio";


let isAtualizandoToken  = false;
let filaRequisicoes     = [];

const setup = (store, axios) => {    
    axios.interceptors.request.use(
        (config) => {
            const token = TokenService.getLocalAccessToken();
            if (token) {
                config.headers["Authorization"] = 'Bearer ' + token;
            }
            config.baseURL  = process.env.VUE_APP_BACKEND_URL;
            if (previaStudio.ativa()) Object.assign(config.headers, previaStudio.cabecalhoPara(config));

            try {
                const apiBaseDomain = ".clictecnologia.com.br";
                const url = new URL(config.url, window.location.origin);
                const isSameDomain = url.hostname.endsWith(apiBaseDomain) || url.hostname === "localhost";
                config.withCredentials = isSameDomain;

            } catch (error) {
                console.log("Erro ao processar URL da requisição (validação withCredentials): ", error);
                config.withCredentials = false;
            }
            return config;
        },
        (error) => {
            return Promise.reject(error);
        }
    );

    axios.interceptors.response.use(
        (res) => {
            return res;
        },
        async (err) => {
            let originalConfig = err.config;             
            previaStudio.tratarErro(err);

            if  (err.response.status == 401) {

                if (originalConfig._retry) {
                    store.dispatch('auth/logout');
                    return Promise.reject(err);
                }

                if (originalConfig.url === "/auth/refresh") {
                    store.dispatch('auth/logout');
                    return Promise.reject(err);
                
                } else {
                    if  (!isAtualizandoToken) {
                        isAtualizandoToken = true;
                        originalConfig._retry = true; 
                        return doCallRefreshToken(axios, originalConfig, store);
                    }

                    return new Promise(function(resolve, reject) {
                        filaRequisicoes.push({ resolve, reject });
                    }).then(token => {  
                        originalConfig.headers['Authorization'] = 'Bearer ' + token;
                        originalConfig._retry = true;
                        return axios(originalConfig);
                    })
                    .catch(err => {
                        return Promise.reject(err);
                    });
                }
            }
            return Promise.reject(err);
        }
    );
};



const doCallRefreshToken = (axios, originalConfig, store) => { 
    return AuthService.refreshToken()
        .then((accessToken) => {          
            originalConfig.headers['Authorization'] = 'Bearer ' + accessToken;
            // store.dispatch('auth/refreshToken', accessToken);
            processarFilaRequisicoes(null, accessToken);
            return axios(originalConfig);
        })
        .catch((err) => {
            processarFilaRequisicoes(err, null);
            store.dispatch('auth/logout');
            return Promise.reject(err); 
        })
        .finally(() => {
            isAtualizandoToken = false;
        });
}

const processarFilaRequisicoes = (error, token = null) => {
    filaRequisicoes.forEach(prom => {
        if (error) {
            prom.reject(error);
        } else {
            prom.resolve(token);
        }
    });
    filaRequisicoes = [];
};


export default setup;

